<template>
  <div class="container">
    <div class="row">
      <div class="col-6">
        <h3>Sign up</h3>
      </div>
      <div class="col-5 offset-1">
        <h1>Login</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <p>You can sign up in the application by using one of the following ways:</p>
        <ul>
          <li>Through this application, through the <router-link to="/auth/signup">sign-up form</router-link>,</li>
          <li>Using the CLI application (see below).</li>
        </ul>

        <strong>Sign up through the CLI application.</strong>
        <pre class="beast-code"><code>beast login [--repo=&lt;name of the repository&gt;]</code></pre>
      </div>
      <div class="col-5 offset-1">
        <form method="#" action="#" v-on:submit.prevent="handleLogin">
          <div class="alert alert-danger text-center" v-show="hasErrors" v-text="errorMessage"></div>
          <div class="form-group">
            <label>Username/Email</label>
            <input class="form-control" name="username" type="text" v-model="model.username"
                   placeholder="Username/Email"/>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input class="form-control" name="password" type="password" v-model="model.password"
                   placeholder="Password"/>
          </div>
          <div class="form-check">
            <input type="checkbox" class="form-check-input" name="rememberMe" v-model="model.rememberMe"
                   id="rememberMe">
            <label class="form-check-label" for="rememberMe">Remember Me</label>
          </div>
          <button type="submit" class="btn btn-block btn-info btn-wd">Login</button>
          <router-link to="/auth/forgot-password"
                       class="btn btn-block btn-link btn-wd">
            Forgot your password
          </router-link>
        </form>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      model: {
        username: "",
        password: "",
        rememberMe: false
      },
      hasErrors: false,
      errorMessage: ""
    };
  },
  methods: {
    handleLogin() {
      this.hasErrors = false;

      this.$auth
        .login({
          data: {
            username: this.model.username,
            password: this.model.password,
            rememberMe: this.model.rememberMe
          },
          rememberMe: this.model.rememberMe,
          redirect: "/"
        })
        .catch((error) => {
          this.hasErrors = true;
          if (error.response) {
            this.errorMessage = error.response.data.message;
          } else {
            this.errorMessage = error;
          }
        });
    }
  },
  mounted() {
    this.setTitle("Login");
  }
};
</script>
<style scoped>
  .navbar-nav .nav-item p {
    line-height: inherit;
    margin-left: 5px;
  }

  .btn-wd{
    margin-top: 10px;
  }
</style>
